import React from 'react'
import {
  ChevronLeft,
  ChevronRight
} from 'react-feather'
import PropTypes from 'prop-types'

const Item = ({
  children,
  active,
  className,
  style,
  ...props
}) => {
  return (
    <div
      className={`mx-3 ${active ? 'text-primary' : 'cursor-pointer'} ${className}`}
      style={{ userSelect: 'none', ...style}}
      {...props}
    >
      {children}
    </div>
  )
}

const Pagination = ({itemsPerPage, totalItems, onChange, defaultCurrentPage = 1}) => {
  const [currentPage, setCurrentPage] = React.useState(defaultCurrentPage)
  const totalPages = totalItems && itemsPerPage ? Math.ceil(totalItems/itemsPerPage) : 0;
  const pages = [...Array(totalPages).keys()]

  React.useEffect(() => {
    onChange(currentPage)
    //eslint-disable-next-line
  }, [currentPage])

  const handlePrev = () => {
    if(currentPage > 1){
      setCurrentPage(currentPage-1)
    }
  }

  const handleNext = () => {
    if(currentPage < totalPages){
      setCurrentPage(currentPage+1)
    }
  }

  const goTo = (page) => {
    setCurrentPage(page)
  }

  return (
    <>
      <div className="flex justify-center text-gray-999 mt-8 lg:mt-16 mb-8">
        <Item onClick={handlePrev}><ChevronLeft/></Item>
        <div style={{maxWidth: '400px'}} className="overflow-x-auto flex">
          {
            pages.map((p, index) => (
              <Item
                key={index+p}
                active={index+1 === currentPage ? true : false}
                onClick={() => goTo(index+1)}
              >
                {index+1}
              </Item>
            ))
          }
        </div>
        <Item onClick={handleNext}><ChevronRight/></Item>
      </div>
    </>
  )
}

Pagination.propTypes = {
  itemsPerPage: PropTypes.number,
  totalItems: PropTypes.number,
  onChange: PropTypes.func,
}

Pagination.defaultProps = {
  itemsPerPage: 5,
  totalItems: 20,
  onChange: (e) => {console.log(e)}
}

export { Pagination }
